<p8-disclaimer-test></p8-disclaimer-test>
<div [ngClass]="[mainStyle.themeName, interlignage, police]">
  <div *ngIf="!activityReadOnly">
    <app-activities [mainStyle]="mainStyle" [interlignage]="interlignage" [police]="police"></app-activities>
  </div>
  <div *ngIf="activityReadOnly">
    <app-activity-detail [activity]="activityDetail" [connecte]="undefined" [campagne]="undefined" (goList)="goHome()"></app-activity-detail>
  </div>
</div>

